const cdn_url = (path) => {
  try {
    return `${_cdn_v2}/images/${path}`;
  } catch (e) {
    console.error(e);
    return '#';
  }
};

export default {
  methods: { cdn_url },
};

export { cdn_url };
